import { render, staticRenderFns } from "./detection-corpus-structure-update.vue?vue&type=template&id=64088022&"
import script from "./detection-corpus-structure-update.vue?vue&type=script&lang=js&"
export * from "./detection-corpus-structure-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports